
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if we should redirect to registration directly
    const shouldRedirect = true; // Set to false if you want to keep this landing page
    
    if (shouldRedirect) {
      navigate("/register");
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md text-center">
        <h1 className="text-3xl font-bold tracking-tighter">Senior Roll Call</h1>
        <p className="text-gray-500">Welcome to Senior Roll Call, a safety check-in service for seniors.</p>
        
        <div className="space-y-4">
          <Button 
            className="w-full bg-black hover:bg-gray-800"
            onClick={() => navigate("/register")}
          >
            Sign Up
          </Button>
          
          <div className="text-sm text-gray-600">
            Already have an account?{" "}
            <Link to="/login" className="text-blue-600 hover:text-blue-800">
              Log In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
